import classnames from "classnames";
import Button from "rivals/components/shared/Button";
import CustomButton from "rivals/components/shared/CustomButton";
import { setData } from "rivals/shared/utils/qa";
import commonStyles from "rivals/styles/exports.module.scss";
import styles from "./ProductCard.module.scss";
import Props from "./types";

const DATA_PHILTER = "product-card";

/**
 * The ProductCard is used to display products for purchase throughout the application
 *
 * The first application will be upsells and add ons.
 *
 * The future plan is to also use cards for Subscriptions as well.
 *
 * If designs deviate significantly between Upsells and Subscriptions,
 * we can make another card.
 */
function ProductCard({
  active = false,
  body,
  ctaCallback,
  ctaIcon,
  ctaText,
  headline,
  inactive = false,
  indicatorText,
  indicatorIcon,
  linkText,
  philter,
  price,
  theme = "default"
}: Props): JSX.Element {
  const link = linkText && (
    <div>
      <CustomButton
        buttonText={linkText}
        className={styles.linkButton}
        philter={"link"}
      />
    </div>
  );

  /**
   * This approach only makes sense with a single alternate theme
   * IF more themes are added, don't just make a bunch of copies of this line
   * Future iterations may include themeing based on site settings data
   */
  const isDarkTheme = theme === "dark";

  const button = ctaText && (
    <div className={styles.buttonWrapper}>
      <Button
        backgroundColor={isDarkTheme ? commonStyles["white"] : undefined}
        borderColor={isDarkTheme ? commonStyles["transparent"] : undefined}
        buttonText={ctaText}
        data={philter}
        inverted
        leadingIcon={ctaIcon}
        onClick={ctaCallback}
        size="small"
      />
    </div>
  );

  const showIndicator = !!(indicatorText || indicatorIcon);

  const indicator = showIndicator && (
    <div className={styles.indicator} {...setData("test")}>
      {indicatorText}
      {indicatorIcon && (
        <div className={styles.indicatorIcon}>{indicatorIcon}</div>
      )}
    </div>
  );

  const classNames = classnames(
    styles.container,
    { [styles.inactive]: inactive },
    { [styles.darkTheme]: isDarkTheme }
  );

  return (
    <div className={classNames} {...setData(philter, DATA_PHILTER)}>
      <div className={styles.description}>
        <div className={styles.headline}>
          <span className={styles.headlineText}>{headline}</span>
          {active && indicator}
        </div>
        <div className={styles.price}>{price}</div>
        <span className={styles.body}>{body}</span>
        {link}
      </div>
      {button}
    </div>
  );
}

export default ProductCard;
